
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';
import { DownloadUrls, So360DownloadCallbackData } from '../config/types';
import Footer from '../components/Footer.vue';
import PcVideoSection from './PcVideoSection.vue';
import PcGameListSection from './PcGameListSection.vue';
import { isMobile } from '@/utils/tool';
import { downloadResolvedFile } from '../utils/resolveDownloadUrl';

@Component({
  components: { Footer, PcVideoSection, PcGameListSection },
})
export default class PcPage extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ default: false }) public hideList!: boolean;
  @Prop({ default: false }) public showAppInfo!: boolean;
  @Prop({ default: false }) public isBaiduDeveloper!: boolean;
  @Prop({ default: true }) public showAddress!: boolean;
  @Prop({ default: '' }) public developerName!: string;
  @Prop({ default: '' }) public baiduApiToken!: string;
  @Prop() public so360DownloadConfig?: So360DownloadCallbackData;

  public downloadClientType = DOWNLOAD_CLIENT_TYPE;

  public handleDownload(type: string) {
    if (!this.downloadUrls[type][process.env.NODE_ENV]) {
      return;
    }
    if (type === DOWNLOAD_CLIENT_TYPE.ANDROID && !isMobile()) {
      return;
    }
    const rawUrl = this.downloadUrls[type][process.env.NODE_ENV];
    downloadResolvedFile(rawUrl, type, {
      baiduApiToken: this.baiduApiToken,
      so360DownloadConfig: this.so360DownloadConfig,
      query: this.$route.query,
    });
  }
}
